import { createContext } from 'react';
export const TripContext = createContext();